import { Typography, TypographyProps } from "@mui/material";
import * as React from "react";

type Props = Omit<TypographyProps, "variant" | "sx">;

export const MprcCardPrimaryText: React.FC<Props> = ({ children, ...rest }) => {
    return (
        <Typography
            {...rest}
            variant="h5"
            sx={{ textTransform: "uppercase" }}
        >
            {children}
        </Typography>
    );
};

